import { MemoryCache, setCache } from '@ms/yammer-libs-cache';

export type SetupCache = () => void;

export const setupCache: SetupCache = () => {
  setCache(new MemoryCache());
};
